export enum SearchEntityTypes { 
    part = "PART",
    page = "PAGE", 
    book = "BOOK", 
    document = "DOCUMENT", 
    external = "EXTERNAL", 
    microsite = "MICROSITE",
    video = "VIDEO",
    image = "IMAGE"
}